var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreepoints(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 8.83301C2.46032 8.83301 2.83341 8.45991 2.83341 7.99967C2.83341 7.53944 2.46032 7.16634 2.00008 7.16634C1.53984 7.16634 1.16675 7.53944 1.16675 7.99967C1.16675 8.45991 1.53984 8.83301 2.00008 8.83301Z",
    stroke: "#475467",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 2.99967C2.46032 2.99967 2.83341 2.62658 2.83341 2.16634C2.83341 1.7061 2.46032 1.33301 2.00008 1.33301C1.53984 1.33301 1.16675 1.7061 1.16675 2.16634C1.16675 2.62658 1.53984 2.99967 2.00008 2.99967Z",
    stroke: "#475467",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 14.6663C2.46032 14.6663 2.83341 14.2932 2.83341 13.833C2.83341 13.3728 2.46032 12.9997 2.00008 12.9997C1.53984 12.9997 1.16675 13.3728 1.16675 13.833C1.16675 14.2932 1.53984 14.6663 2.00008 14.6663Z",
    stroke: "#475467",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreepoints);
export default __webpack_public_path__ + "static/media/threepoints.6119d74dc94ed70f2cf415e63dece6e1.svg";
export { ForwardRef as ReactComponent };